import { createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../api/apiClient';

export const submitAgreement = createAsyncThunk(
  'unifiedForm/submitAgreement',
  async (publisherId: string, { rejectWithValue }) => {
    try {
      const response = await apiClient.post(`/v2/publisher/agreement/${publisherId}`, {});
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message || 'خطا در ارسال قرارداد');
    }
  }
);